import QuickHelpSection from './QuickHelpSection';

export default QuickHelpSection;